import type { RasterLayerSource } from '@/hooks/useDatasets';

/**
 * The tiler path template for a raster layer's tiles. The tiler looks the
 * mosaic up from the release and layer type, so the browser never names one.
 */
export const releaseTilesPath = (
  source: RasterLayerSource,
  format: 'png' | 'webp'
) =>
  `/mosaicjson/releases/${source.releaseId}/${source.layerType}/tiles/WebMercatorQuad/{z}/{x}/{y}.${format}`;
